import React from 'react'
import './Auth.css'
import config from 'custom/config/environment'
import AuthSlideLayout from './auth-slide-layout'
import AuthStaticLayout from './auth-static-layout'

export default function AuthLayout({ children }) {
  return (
    <div className='container-fluid'>
     {config.AUTH_LAYOUT_TYPE==="SLIDE" && <AuthSlideLayout children={children}/>}
     {config.AUTH_LAYOUT_TYPE==="STATIC" && <AuthStaticLayout children={children}/>}
    </div>
  )
}
